import { Container, useTheme } from "@mui/material";
import * as React from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function Booths() {
  const theme = useTheme();
  const history = useHistory();

  //   const exhibition = APP.arrangement?.state.exhibition;
  //   const boothSet = exhibition?.BoothSet;
  const booths = APP.richMetadata.getAllBooths(); //boothSet ? boothSet?.BoothsForBoothSets.map((bfbs) => bfbs.Booth) : [];

  const getDefaultArticleForBooth = (booth) => {
    const defaultForm = APP.richMetadata.metadata.FormsForBooths.find(
      (formforbooth) => formforbooth.Booth == booth
    );
    return defaultForm?.Article;
  };

  const handleBoothClick = async (event, booth) => {
    const boothModel = booth;
    APP.arrangement.resetBoothCustomization();
    APP.arrangement.booth.clearInteriors();

    if (!booth.Inspiration) {
      history.push(`/${booth.id}/configurator`);
      APP.arrangement.createDefaultArrangement(APP.parseParams(), null);
    } else {
      history.push(`/${booth.id}/configurator/${booth.Inspiration}`);
      const configuration = await APP.createConfigurationFromCode(booth.Inspiration);
      APP.arrangement.createDefaultArrangement(APP.parseParams(), configuration);
    }
    APP.dirty();
  };

  return (
    <Box sx={{ paddingTop: "22px" }}>
      <Container>
        <Grid container spacing={2}>
          {booths.length > 0 ? (
            booths.map((item) => (
              <Grid item key={item.Displayed_Name || item.Code} xs={12} sm={6} md={4} lg={3}>
                <Box
                  onClick={(event) => handleBoothClick(event, item)}
                  sx={{
                    position: "relative",
                    width: "100%",
                    padding: "10px 13px",
                    border: "1px solid #E2E2E2",
                    borderRadius: "10px",
                    height: "100%",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    transition: "all 0.3s",
                    overflow: "hidden",
                    "&:hover": {
                      boxShadow: 4,
                      transform: "translate(0,-5px)",
                      img: {
                        transform: "scale(1.2)",
                      },
                    },
                  }}
                >
                  {(item.FormsForBooths?.filter((b) => b.Default)[0]?.Thumbnail ||
                    item.GeneratedThumbnail) && (
                    <Box
                      sx={{
                        overflow: "hidden",
                        width: "100%",
                        height: "150px",
                        borderRadius: "10px",
                        marginBottom: 2,
                      }}
                    >
                      <img
                        src={`${
                          item.GeneratedThumbnail ||
                          item.FormsForBooths.filter((b) => b.Default)[0].Thumbnail
                        }`}
                        alt={item.Displayed_Name}
                        style={{
                          borderRadius: "10px",
                          width: "100%",
                          height: "150px",
                          objectFit: "cover",
                          overflow: "hidden",
                          transition: "all 0.3s",
                        }}
                      />
                    </Box>
                  )}
                  <Typography
                    gutterBottom
                    variant="body1"
                    component="div"
                    sx={{ fontWeight: 700, color: "#3A415A" }}
                  >
                    {item.Displayed_Name || item.Code}
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="small" sx={{ color: "#939599", fontSize: "14px" }}>
                      {_.uniq(item.FormsForBooths?.map((b) => b.Size?.Label)).join(", ")}
                    </Typography>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ fontWeight: 700, color: "#3A415A" }}
                    >
                      {getDefaultArticleForBooth(item)
                        ? APP.formatter.format(getDefaultArticleForBooth(item).Preis)
                        : ""}
                    </Typography>
                  </Box>
                  {item.IsHot && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "18px",
                        left: 0,
                        background: "linear-gradient(180deg, #E94452 0%, #EC622F 100%)",
                        borderRadius: "0 4px 4px 0",
                        padding: "5px",
                        width: "70px",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" sx={{ color: "#fff", fontWeight: "700" }}>
                        {I18N("HotBanner")}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid>
            ))
          ) : (
            <p>{I18N("No Booths found")}</p>
          )}
        </Grid>
      </Container>
      <Box
        sx={{
          height: "50px",
          [theme.breakpoints.up("lg")]: {
            height: "59px",
          },
        }}
      />
    </Box>
  );
}
